import React from "react";

/**
 * Controlled StringType component.
 *
 * Props:
 *   attribute  – { type: "string", attributeName: string, data: string, long?: boolean }
 *   onChange   – (updatedAttribute) => void
 *   onDelete   – () => void
 *   language   – "en" | "zh"
 */
export const StringType = ({
    attribute,
    onChange,
    onDelete,
    language = "en",
}) => {

    const updateName = (value) => {
        onChange({ ...attribute, attributeName: value });
    };

    const updateValue = (value) => {
        onChange({ ...attribute, data: value });
    };

    return (
        <div className="rounded-lg border border-gray-200 overflow-hidden">
            {/* ── Title bar ── */}
            <div className="bg-[#3C3C3C] px-4 py-3 flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 flex-1 min-w-0">
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-gray-200 text-gray-700 shrink-0">
                        {language === "zh" ? "文本" : "Text"}
                    </span>
                    <input
                        type="text"
                        value={attribute.attributeName}
                        placeholder={
                            language === "zh" ? "屬性名稱" : "Attribute name"
                        }
                        className="flex-1 bg-transparent border-0 border-b-2 border-gray-200 focus:border-white px-1 py-0.5 text-sm font-medium text-white focus:outline-none placeholder-gray-400 transition-colors"
                        onChange={(e) => updateName(e.target.value)}
                    />
                </div>
                <button
                    type="button"
                    className="p-1.5 text-red-500 hover:text-red-600 hover:bg-red-50 rounded-full transition-colors shrink-0"
                    onClick={onDelete}
                    title={language === "zh" ? "刪除屬性" : "Delete attribute"}
                >
                    <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            fillRule="evenodd"
                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                            clipRule="evenodd"
                        />
                    </svg>
                </button>
            </div>

            {/* ── Value section ── */}
            <div className="bg-white px-4 py-3 flex flex-col gap-2">
                {/* <div className="flex items-center justify-between">
                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                        {language === "zh" ? "值" : "Value"}
                    </label>
                    <label className="flex items-center gap-1.5 cursor-pointer select-none">
                        <span className="text-xs text-gray-500">
                            {language === "zh" ? "長文字" : "Long text"}
                        </span>
                        <button
                            type="button"
                            role="switch"
                            aria-checked={isLong}
                            onClick={toggleLong}
                            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
                                isLong ? "bg-blue-500" : "bg-gray-300"
                            }`}
                        >
                            <span
                                className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform ${
                                    isLong
                                        ? "translate-x-[18px]"
                                        : "translate-x-[3px]"
                                }`}
                            />
                        </button>
                    </label>
                </div> */}

                {/* {isLong ? ( */}
                <textarea
                    value={attribute.data || ""}
                    rows={3}
                    placeholder={
                        language === "zh" ? "輸入內容..." : "Enter content..."
                    }
                    className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-y"
                    onChange={(e) => updateValue(e.target.value)}
                />
                {/* ) : (
                    <input
                        type="text"
                        value={attribute.data || ""}
                        placeholder={
                            language === "zh" ? "輸入值" : "Enter value"
                        }
                        className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        onChange={(e) => updateValue(e.target.value)}
                    />
                )} */}
            </div>
        </div>
    );
};
